import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SignApi } from '~/components/sign'
import {} from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'sign',
  setup(__props) {

function submit(form: SignApi) {
  console.log(form)
}

return (_ctx: any,_cache: any) => {
  const _component_u_sign = _resolveComponent("u-sign")!

  return (_openBlock(), _createBlock(_component_u_sign, { onSubmit: submit }))
}
}

})